export const PageHeader = {
  flow: 'x',
  align: 'center space-between',
  padding: 'Z A',
  borderBottomWidth: '1px',
  borderBottomColor: 'line',
  borderBottomStyle: 'solid',
  minHeight: 'D',
  gap: 'A',
  background: 'overlayStrong',
  color: 'title',
  position: 'sticky',
  top: '0',
  zIndex: '20',

  LeftGroup: {
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    flex: '1',
    minWidth: '0'
  },

  CenterGroup: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  },

  RightGroup: {
    flow: 'x',
    align: 'center right',
    gap: 'Z1'
  }
}
